import { render, staticRenderFns } from "./partList-add-or-update.vue?vue&type=template&id=7f71d1ce"
import script from "./partList-add-or-update.vue?vue&type=script&lang=js"
export * from "./partList-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./partList-add-or-update.vue?vue&type=style&index=0&id=7f71d1ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports